"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactFontawesome = _interopRequireDefault(require("react-fontawesome"));

var _NavigationBar = _interopRequireDefault(require("./NavigationBar.scss"));

var _Constants = require("../../constants/Constants");

var _NavigationManagerCordova = _interopRequireDefault(require("../../NavigationManagerCordova"));

var _ThemeStore = _interopRequireDefault(require("../ThemeStore/ThemeStore2"));

var _TimeoutHelper = require("../../../helpers/TimeoutHelper");

var _cssConstants = _interopRequireDefault(require("../../../../targets/cord_eurofh_teams/cssConstants.js"));

var _config = _interopRequireDefault(require("../../../../targets/cord_eurofh_teams/config.js"));

var _ObjectHelper = require("../../../helpers/ObjectHelper");

var _ColorHelper = require("../../../helpers/ColorHelper");

var _DataStore = _interopRequireWildcard(require("../../../KESI2/Stores/DataStore2"));

var _KESI2Helper = _interopRequireWildcard(require("../../../KESI2/KESI2Helper"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../helpers/DeviceInfoHelper"));

var _Image = _interopRequireDefault(require("../Image/Image"));

var _DataStoreComponent2 = _interopRequireDefault(require("../DataStoreComponent/DataStoreComponent2"));

var _ArrowBackIos = _interopRequireDefault(require("@material-ui/icons/ArrowBackIos"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _TilesColorHelper = _interopRequireDefault(require("../DrupalTiles/TilesColorHelper"));

var _FormatSize = _interopRequireDefault(require("@material-ui/icons/FormatSize"));

var _InvertColors = _interopRequireDefault(require("@material-ui/icons/InvertColors"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var NavigationBarGeneric = /*#__PURE__*/function (_DataStoreComponent) {
  (0, _inherits2["default"])(NavigationBarGeneric, _DataStoreComponent);

  var _super = _createSuper(NavigationBarGeneric);

  function NavigationBarGeneric(props) {
    var _thisSuper, _thisSuper2, _this;

    (0, _classCallCheck2["default"])(this, NavigationBarGeneric);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "checkEnterKey", function (event) {
      if (event.key === 'Enter') {
        var el = document.activeElement;

        if (el) {
          if (el.id === 'backBtn') {
            var goBackFn = _this.goBack();

            if (goBackFn) goBackFn();
          } else if (el.id === 'toggleSizeBtn') {
            _this.toggleFontSize();
          } else if (el.id === 'invertBtn') {
            _this.invertColors();
          }
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "innerForceUpdate", function () {
      _this.forceUpdate();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "toggleFontSize", function () {
      var isZoomed = _this.state.contentZoomed;
      var el = document.getElementById('tileRoot');
      var scrollFrames = document.getElementsByClassName('scrollFrame');
      var lectureFrame = document.getElementById('lecture_scroll_frame');
      console.log('isZoomed, el', isZoomed, el);

      if (el) {
        if (!isZoomed) {
          el.style.transform = 'perspective(1px) scale(2.0) translate3d(0,0,0)';
          el.style.paddingTop = "".concat(50 * 0.5, "px");

          for (var i = 0; i < scrollFrames.length; i++) {
            var screenHeight = el.offsetHeight;
            var screenWidth = el.offsetWidth;
            var neededWidth = 2 * _cssConstants["default"].appMaxWidth;
            var child = scrollFrames[i] && scrollFrames[i].children && scrollFrames[i].children.length > 0 ? scrollFrames[i].children[0] : null;

            if (child) {
              var tileFrame = document.querySelector('[id^="tiles-frame2-not-background"]'); // because overflow is changing, the height is changing. Hardcoded for now...

              var neededHeight = 2 * 924; //tileFrame.offsetHeight

              console.log('setZoomStyles Navbar', screenHeight, neededHeight, tileFrame);
              child.style.height = "".concat((screenHeight + neededHeight - 50) / 2, "px");
              var calculatedWidthPercentage = ((neededWidth / screenWidth - 1) / 2 + 1) * 100;
              child.style.width = "".concat(calculatedWidthPercentage, "%");

              if (calculatedWidthPercentage > 100) {
                if (tileFrame) {
                  var tileFrameChild = tileFrame && tileFrame.children && tileFrame.children.length > 0 ? tileFrame.children[0] : null;

                  if (tileFrameChild) {
                    tileFrameChild.style.margin = '0';
                  }
                }

                var lectureFrameChild = lectureFrame && lectureFrame.children && lectureFrame.children.length > 0 ? lectureFrame.children[0] : null;

                if (lectureFrameChild) {
                  lectureFrameChild.style.margin = '0';
                }
              } else {
                if (tileFrame) {
                  var _tileFrameChild = tileFrame && tileFrame.children && tileFrame.children.length > 0 ? tileFrame.children[0] : null;

                  if (_tileFrameChild) {
                    _tileFrameChild.style.margin = "0 ".concat((100 - calculatedWidthPercentage) / 2, "%");
                  }
                }

                var _lectureFrameChild = lectureFrame && lectureFrame.children && lectureFrame.children.length > 0 ? lectureFrame.children[0] : null;

                if (_lectureFrameChild) {
                  _lectureFrameChild.style.margin = "0 ".concat((100 - calculatedWidthPercentage) / 2, "%");
                }
              }
            }
          }

          if (lectureFrame) {
            lectureFrame.style.height = '49%';
          }
        } else {
          el.style.transform = 'perspective(0) scale(1.0) translate3d(0,0,0)';
          el.style.paddingTop = '50px';

          for (var _i = 0; _i < scrollFrames.length; _i++) {
            var scrollFrame = scrollFrames[_i]; // scrollFrame.style.overflow = 'hidden scroll'

            scrollFrame.scrollLeft = 0;

            var _child = scrollFrames[_i] && scrollFrames[_i].children && scrollFrames[_i].children.length > 0 ? scrollFrames[_i].children[0] : null;

            if (_child) _child.style.height = '100%';
          }

          if (lectureFrame) {
            lectureFrame.style.height = '100%';

            var _lectureFrameChild2 = lectureFrame && lectureFrame.children && lectureFrame.children.length > 0 ? lectureFrame.children[0] : null;

            if (_lectureFrameChild2) {
              _lectureFrameChild2.style.margin = 'auto';
            }
          }

          var _tileFrame = document.querySelector('[id^="tiles-frame2-not-background"]');

          if (_tileFrame) {
            var _tileFrameChild2 = _tileFrame && _tileFrame.children && _tileFrame.children.length > 0 ? _tileFrame.children[0] : null;

            if (_tileFrameChild2) {
              _tileFrameChild2.style.margin = '0 auto';
            }
          }
        }

        _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.IS_ZOOMED, !isZoomed, false);

        _this.setState({
          contentZoomed: !isZoomed
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "invertColors", function () {
      var isInverted = _this.state.isInverted;
      var css = 'html {-webkit-filter: invert(100%);' + '-moz-filter: invert(100%);' + '-o-filter: invert(100%);' + '-ms-filter: invert(100%); }' + 'img:not(.tileBackground) {-webkit-filter: invert(100%) !important;' + '-moz-filter: invert(100%) !important;' + '-o-filter: invert(100%) !important;' + '-ms-filter: invert(100%) !important; }' + '.tileBackgroundContainer {-webkit-filter: invert(100%);' + '-moz-filter: invert(100%);' + '-o-filter: invert(100%);' + '-ms-filter: invert(100%); }' + 'video {-webkit-filter: invert(100%);' + '-moz-filter: invert(100%);' + '-o-filter: invert(100%);' + '-ms-filter: invert(100%); }' + '.doNotInvert {-webkit-filter: invert(100%);' + '-moz-filter: invert(100%);' + '-o-filter: invert(100%);' + '-ms-filter: invert(100%); }' + 'a {-webkit-filter: invert(100%);' + '-moz-filter: invert(100%);' + '-o-filter: invert(100%);' + '-ms-filter: invert(100%); }';
      var head = document.getElementsByTagName('head')[0];
      var style = document.createElement('style');
      style.id = 'invert';

      if (isInverted) {
        var _style = document.getElementById('invert');

        _style.parentElement.removeChild(_style);

        _this.setState({
          isInverted: false
        });
      } else {
        style.type = 'text/css';

        if (style.styleSheet) {
          style.styleSheet.cssText = css;
        } else {
          style.appendChild(document.createTextNode(css));
        }

        head.appendChild(style);

        _this.setState({
          isInverted: true
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderFeedbackIcon", function (dynamicStyles) {});
    _this.state = {
      navbar: null,
      showFavs: false,
      remoteSyncEnabled: true,
      contentZoomed: false,
      isInverted: false
    };
    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(NavigationBarGeneric.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.FILTER_FAVORITES, _DataStore.DATA_STORE_PATHS.TC_WARNING_ACTIVATED, _DataStore.DATA_STORE_PATHS.ERGO_USER_DATA, _DataStore.DATA_STORE_PATHS.TC_HOME_REGION_CODE]);
    (0, _get2["default"])((_thisSuper2 = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(NavigationBarGeneric.prototype)), "addStoresAndKeys", _thisSuper2).call(_thisSuper2, [{
      store: _ThemeStore["default"],
      keys: ['navbar', 'currentTheme']
    }]);
    return _this;
  }

  (0, _createClass2["default"])(NavigationBarGeneric, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      _DeviceInfoHelper["default"].addOnlineListener(this.innerForceUpdate);

      _DeviceInfoHelper["default"].addOfflineListener(this.innerForceUpdate);

      if (!_DeviceInfoHelper["default"].isBrowser()) {
        window.screen.orientation.addEventListener('change', this.innerForceUpdate);
      } else {
        window.addEventListener('keypress', function (event) {
          return _this2.checkEnterKey(event);
        });
      } // this.setState({remote

    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this3 = this;

      _DeviceInfoHelper["default"].removeOnlineListener(this.innerForceUpdate);

      _DeviceInfoHelper["default"].removeOfflineListener(this.innerForceUpdate);

      if (_DeviceInfoHelper["default"].isBrowser()) {
        window.removeEventListener('keypress', function (event) {
          return _this3.checkEnterKey(event);
        });
      }
    }
  }, {
    key: "getStyles",
    // TODO: tidy up, make target independent
    value: function getStyles() {
      var _targetCss$navbar, _targetCss$navbarMobi, _targetCss$navbar2, _targetCss$navbarMobi2, _targetCss$navbar3, _targetCss$navbarMobi3, _targetCss$navbar4, _targetCss$navbarMobi4, _targetCss$navbar5, _targetCss$navbarMobi5, _targetCss$navbar6, _targetCss$navbarMobi6, _targetCss$navbar7, _targetCss$navbarMobi7, _targetCss$navbar8, _targetCss$navbarMobi8, _targetCss$navbar9, _targetCss$navbarMobi9, _targetCss$navbar10, _targetCss$navbarMobi10, _targetCss$navbar11, _targetCss$navbarMobi11, _targetCss$navbar12, _targetCss$navbarMobi12, _targetCss$navbar13, _targetCss$navbarMobi13, _targetCss$navbar15, _targetCss$navbarMobi15;

      var burgerStyle = {};
      var iconStyle = {};
      var settingsIconStyle = {};
      var countStyle = {};
      var navbarContainerLeftStyle = {};
      var backButtonContainerStyle = {};
      var backButtonIconStyle = {};
      var navbarContainerRightStyle = {};
      var learningStateIconStyle = {};
      var titleIconStyle = {};
      var titleTextStyle = {};
      var navbarBorderStyle = {};
      var disablityStyle = {};
      var feedbackStyle = {};
      var isLandscape = !_DeviceInfoHelper["default"].isBrowser() && window.screen && window.screen.orientation && window.screen.orientation.type && window.screen.orientation.type.startsWith('landscape');
      var theme = null;

      if (this.state.navbar && this.state.currentTheme in this.state.navbar) {
        theme = this.state.navbar[this.state.currentTheme];
      }

      var defaultTheme = this.state.navbar ? this.state.navbar["default"] : null;

      var backgroundColor = _NavigationManagerCordova["default"].getNavbarBackgroundColor();

      var navbarStyle = {
        backgroundColor: backgroundColor || (0, _ObjectHelper.getObjectValueWithFallbacks)(theme, 'navbarBackground', defaultTheme, 'navbarBackground', _ColorHelper.COLOR.WHITE),
        color: (0, _ObjectHelper.getObjectValueWithFallbacks)(theme, 'navbarText', defaultTheme, 'navbarText', _ColorHelper.COLOR.BLACK),
        // TODO: Add extra spacing for the ios notch at the top of the iphone x/xs etc
        height:
        /*DeviceInfoHelper.isiOS() && window.screen.availHeight > 736 ? `${targetCss.navBarHeight + 24}px` :*/
        "".concat(_cssConstants["default"].navBarHeight, "px"),
        zIndex: _Constants.GLOBAL_Z_INDEXES.navbar,
        position: _config["default"].navbarFixed ? 'fixed' : 'absolute',
        borderBottom: _cssConstants["default"].colors.navbarBorderBottom ? _cssConstants["default"].colors.navbarBorderBottom : 0,
        maxWidth: _cssConstants["default"].navbarMaxWidth ? _cssConstants["default"].navbarMaxWidth : _cssConstants["default"].appMaxWidth ? _cssConstants["default"].appMaxWidth : 1024,
        left: 0,
        right: 0,
        margin: 'auto'
      };

      if (this.props.showMenuButton) {
        burgerStyle = {
          color: _cssConstants["default"].colors.navbarItemColor ? _cssConstants["default"].colors.navbarItemColor : (0, _ObjectHelper.getObjectValueWithFallbacks)(theme, 'navbarItemColor', defaultTheme, 'navbarItemColor', _ColorHelper.COLOR.BLACK),
          fontSize: '18px',
          visibility: this.props.sidebarDocked || !this.props.onMenuClicked ? 'hidden' : 'visible'
        };
      } else {
        burgerStyle = {
          display: 'none'
        };
      }

      iconStyle = {
        color: _cssConstants["default"].colors.navbarItemColor ? _cssConstants["default"].colors.navbarItemColor : (0, _ObjectHelper.getObjectValueWithFallbacks)(theme, 'navbarItemColor', defaultTheme, 'navbarItemColor', _ColorHelper.COLOR.BLACK)
      };
      settingsIconStyle = (0, _assign["default"])({}, iconStyle);
      countStyle = {
        right: _config["default"].showHomeButton ? '50px' : '15px',
        display: _config["default"].showCounter ? 'initial' : 'none',
        backgroundColor: '#a5a5a5'
      };
      navbarContainerLeftStyle = {
        position: 'absolute',
        left: '10px',
        height: '40px',
        top: _cssConstants["default"].navBarContainerLeftTop ? _cssConstants["default"].navBarContainerLeftTop : 0,
        width: '30%',
        zIndex: 1
      };
      navbarContainerRightStyle = {
        position: 'absolute',
        right: '15px',
        top: _cssConstants["default"].navBarRightSideButtonsTop ? _cssConstants["default"].navBarRightSideButtonsTop : 0,
        zIndex: 1
      };
      backButtonContainerStyle = {
        display: 'inline-block',
        position: 'relative',
        height: '35px',
        width: '50px',
        paddingLeft: '7px',
        cursor: 'pointer',
        transform: 'translate3d(0, 0, 0)',
        zIndex: '1'
      };
      backButtonIconStyle = {
        position: 'relative',
        fontSize: _cssConstants["default"].navbarBackIconSize ? _cssConstants["default"].navbarBackIconSize : 28,
        top: _cssConstants["default"].navBarBackIconTop ? _cssConstants["default"].navBarBackIconTop : 0,
        color: _cssConstants["default"].colors.navbarItemColor ? _cssConstants["default"].colors.navbarItemColor : (0, _ObjectHelper.getObjectValueWithFallbacks)(theme, 'navbarItemColor', defaultTheme, 'navbarItemColor', _ColorHelper.COLOR.BLACK)
      };
      titleIconStyle = {};
      titleTextStyle = {
        maxWidth: isLandscape ? _cssConstants["default"].navBarMaxWidth : _cssConstants["default"].navBarMaxWidthPortrait
      };

      if (_config["default"].requiredFeature === 'ergoquiz') {
        return {
          navbar: {
            backgroundColor: this.props.isTraining ? _cssConstants["default"].colors.navbarBackgroundTraining : _cssConstants["default"].colors.navbarBackground,
            color: _cssConstants["default"].colors.navbarText,
            height: '64px',
            top: 0,
            zIndex: _Constants.GLOBAL_Z_INDEXES.navbar
          },
          burger: {
            visibility: this.props.sidebarDocked || !this.props.onMenuClicked ? 'hidden' : 'visible'
          },
          update: {// visibility: this.props.onRefresh ? 'visible' : 'hidden',
          }
        };
      }

      var isMobile = window.innerWidth < _cssConstants["default"].appMaxWidth;

      if ((_cssConstants["default"] === null || _cssConstants["default"] === void 0 ? void 0 : (_targetCss$navbar = _cssConstants["default"].navbar) === null || _targetCss$navbar === void 0 ? void 0 : _targetCss$navbar.navbarStyle) || (_cssConstants["default"] === null || _cssConstants["default"] === void 0 ? void 0 : (_targetCss$navbarMobi = _cssConstants["default"].navbarMobile) === null || _targetCss$navbarMobi === void 0 ? void 0 : _targetCss$navbarMobi.navbarStyle)) {
        navbarStyle = (0, _assign["default"])(navbarStyle, isMobile ? _cssConstants["default"].navbarMobile.navbarStyle : _cssConstants["default"].navbar.navbarStyle);
      }

      if ((_cssConstants["default"] === null || _cssConstants["default"] === void 0 ? void 0 : (_targetCss$navbar2 = _cssConstants["default"].navbar) === null || _targetCss$navbar2 === void 0 ? void 0 : _targetCss$navbar2.titleIconStyle) || (_cssConstants["default"] === null || _cssConstants["default"] === void 0 ? void 0 : (_targetCss$navbarMobi2 = _cssConstants["default"].navbarMobile) === null || _targetCss$navbarMobi2 === void 0 ? void 0 : _targetCss$navbarMobi2.titleIconStyle)) {
        titleIconStyle = (0, _assign["default"])(titleIconStyle, isMobile ? _cssConstants["default"].navbarMobile.titleIconStyle : _cssConstants["default"].navbar.titleIconStyle);
      }

      if ((_cssConstants["default"] === null || _cssConstants["default"] === void 0 ? void 0 : (_targetCss$navbar3 = _cssConstants["default"].navbar) === null || _targetCss$navbar3 === void 0 ? void 0 : _targetCss$navbar3.burgerStyle) || (_cssConstants["default"] === null || _cssConstants["default"] === void 0 ? void 0 : (_targetCss$navbarMobi3 = _cssConstants["default"].navbarMobile) === null || _targetCss$navbarMobi3 === void 0 ? void 0 : _targetCss$navbarMobi3.burgerStyle)) {
        burgerStyle = (0, _assign["default"])(burgerStyle, isMobile ? _cssConstants["default"].navbarMobile.burgerStyle : _cssConstants["default"].navbar.burgerStyle);
      }

      if ((_cssConstants["default"] === null || _cssConstants["default"] === void 0 ? void 0 : (_targetCss$navbar4 = _cssConstants["default"].navbar) === null || _targetCss$navbar4 === void 0 ? void 0 : _targetCss$navbar4.settingsIconStyle) || (_cssConstants["default"] === null || _cssConstants["default"] === void 0 ? void 0 : (_targetCss$navbarMobi4 = _cssConstants["default"].navbarMobile) === null || _targetCss$navbarMobi4 === void 0 ? void 0 : _targetCss$navbarMobi4.settingsIconStyle)) {
        settingsIconStyle = (0, _assign["default"])(settingsIconStyle, isMobile ? _cssConstants["default"].navbarMobile.settingsIconStyle : _cssConstants["default"].navbar.settingsIconStyle);
      }

      if ((_cssConstants["default"] === null || _cssConstants["default"] === void 0 ? void 0 : (_targetCss$navbar5 = _cssConstants["default"].navbar) === null || _targetCss$navbar5 === void 0 ? void 0 : _targetCss$navbar5.disablityStyle) || (_cssConstants["default"] === null || _cssConstants["default"] === void 0 ? void 0 : (_targetCss$navbarMobi5 = _cssConstants["default"].navbarMobile) === null || _targetCss$navbarMobi5 === void 0 ? void 0 : _targetCss$navbarMobi5.disablityStyle)) {
        disablityStyle = (0, _assign["default"])(disablityStyle, isMobile ? _cssConstants["default"].navbarMobile.disablityStyle : _cssConstants["default"].navbar.disablityStyle);
      }

      if ((_cssConstants["default"] === null || _cssConstants["default"] === void 0 ? void 0 : (_targetCss$navbar6 = _cssConstants["default"].navbar) === null || _targetCss$navbar6 === void 0 ? void 0 : _targetCss$navbar6.navbarBorderStyle) || (_cssConstants["default"] === null || _cssConstants["default"] === void 0 ? void 0 : (_targetCss$navbarMobi6 = _cssConstants["default"].navbarMobile) === null || _targetCss$navbarMobi6 === void 0 ? void 0 : _targetCss$navbarMobi6.navbarBorderStyle)) {
        navbarBorderStyle = (0, _assign["default"])(navbarBorderStyle, isMobile ? _cssConstants["default"].navbarMobile.navbarBorderStyle : _cssConstants["default"].navbar.navbarBorderStyle);
      }

      if ((_cssConstants["default"] === null || _cssConstants["default"] === void 0 ? void 0 : (_targetCss$navbar7 = _cssConstants["default"].navbar) === null || _targetCss$navbar7 === void 0 ? void 0 : _targetCss$navbar7.containerLeftStyle) || (_cssConstants["default"] === null || _cssConstants["default"] === void 0 ? void 0 : (_targetCss$navbarMobi7 = _cssConstants["default"].navbarMobile) === null || _targetCss$navbarMobi7 === void 0 ? void 0 : _targetCss$navbarMobi7.containerLeftStyle)) {
        navbarContainerLeftStyle = (0, _assign["default"])(navbarContainerLeftStyle, isMobile ? _cssConstants["default"].navbarMobile.containerLeftStyle : _cssConstants["default"].navbar.containerLeftStyle);
      }

      if ((_cssConstants["default"] === null || _cssConstants["default"] === void 0 ? void 0 : (_targetCss$navbar8 = _cssConstants["default"].navbar) === null || _targetCss$navbar8 === void 0 ? void 0 : _targetCss$navbar8.containerRightStyle) || (_cssConstants["default"] === null || _cssConstants["default"] === void 0 ? void 0 : (_targetCss$navbarMobi8 = _cssConstants["default"].navbarMobile) === null || _targetCss$navbarMobi8 === void 0 ? void 0 : _targetCss$navbarMobi8.containerRightStyle)) {
        navbarContainerRightStyle = (0, _assign["default"])(navbarContainerRightStyle, isMobile ? _cssConstants["default"].navbarMobile.containerRightStyle : _cssConstants["default"].navbar.containerRightStyle);
      }

      if ((_cssConstants["default"] === null || _cssConstants["default"] === void 0 ? void 0 : (_targetCss$navbar9 = _cssConstants["default"].navbar) === null || _targetCss$navbar9 === void 0 ? void 0 : _targetCss$navbar9.backButtonContainerStyle) || (_cssConstants["default"] === null || _cssConstants["default"] === void 0 ? void 0 : (_targetCss$navbarMobi9 = _cssConstants["default"].navbarMobile) === null || _targetCss$navbarMobi9 === void 0 ? void 0 : _targetCss$navbarMobi9.backButtonContainerStyle)) {
        backButtonContainerStyle = (0, _assign["default"])(backButtonContainerStyle, isMobile ? _cssConstants["default"].navbarMobile.backButtonContainerStyle : _cssConstants["default"].navbar.backButtonContainerStyle);
      }

      if ((_cssConstants["default"] === null || _cssConstants["default"] === void 0 ? void 0 : (_targetCss$navbar10 = _cssConstants["default"].navbar) === null || _targetCss$navbar10 === void 0 ? void 0 : _targetCss$navbar10.backButtonIconStyle) || (_cssConstants["default"] === null || _cssConstants["default"] === void 0 ? void 0 : (_targetCss$navbarMobi10 = _cssConstants["default"].navbarMobile) === null || _targetCss$navbarMobi10 === void 0 ? void 0 : _targetCss$navbarMobi10.backButtonIconStyle)) {
        backButtonIconStyle = (0, _assign["default"])(backButtonIconStyle, isMobile ? _cssConstants["default"].navbarMobile.backButtonIconStyle : _cssConstants["default"].navbar.backButtonIconStyle);
      }

      if ((_cssConstants["default"] === null || _cssConstants["default"] === void 0 ? void 0 : (_targetCss$navbar11 = _cssConstants["default"].navbar) === null || _targetCss$navbar11 === void 0 ? void 0 : _targetCss$navbar11.learningStateIconStyle) || (_cssConstants["default"] === null || _cssConstants["default"] === void 0 ? void 0 : (_targetCss$navbarMobi11 = _cssConstants["default"].navbarMobile) === null || _targetCss$navbarMobi11 === void 0 ? void 0 : _targetCss$navbarMobi11.learningStateIconStyle)) {
        learningStateIconStyle = (0, _assign["default"])(learningStateIconStyle, isMobile ? _cssConstants["default"].navbarMobile.learningStateIconStyle : _cssConstants["default"].navbar.learningStateIconStyle);
      }

      if ((_cssConstants["default"] === null || _cssConstants["default"] === void 0 ? void 0 : (_targetCss$navbar12 = _cssConstants["default"].navbar) === null || _targetCss$navbar12 === void 0 ? void 0 : _targetCss$navbar12.feedbackStyle) || (_cssConstants["default"] === null || _cssConstants["default"] === void 0 ? void 0 : (_targetCss$navbarMobi12 = _cssConstants["default"].navbarMobile) === null || _targetCss$navbarMobi12 === void 0 ? void 0 : _targetCss$navbarMobi12.feedbackStyle)) {
        feedbackStyle = (0, _assign["default"])(feedbackStyle, isMobile ? _cssConstants["default"].navbarMobile.feedbackStyle : _cssConstants["default"].navbar.feedbackStyle);
      }

      if ((_cssConstants["default"] === null || _cssConstants["default"] === void 0 ? void 0 : (_targetCss$navbar13 = _cssConstants["default"].navbar) === null || _targetCss$navbar13 === void 0 ? void 0 : _targetCss$navbar13.iconStyle) || (_cssConstants["default"] === null || _cssConstants["default"] === void 0 ? void 0 : (_targetCss$navbarMobi13 = _cssConstants["default"].navbarMobile) === null || _targetCss$navbarMobi13 === void 0 ? void 0 : _targetCss$navbarMobi13.iconStyle)) {
        var _targetCss$navbarMobi14, _targetCss$navbar14;

        iconStyle = (0, _assign["default"])(iconStyle, isMobile ? _cssConstants["default"] === null || _cssConstants["default"] === void 0 ? void 0 : (_targetCss$navbarMobi14 = _cssConstants["default"].navbarMobile) === null || _targetCss$navbarMobi14 === void 0 ? void 0 : _targetCss$navbarMobi14.iconStyle : _cssConstants["default"] === null || _cssConstants["default"] === void 0 ? void 0 : (_targetCss$navbar14 = _cssConstants["default"].navbar) === null || _targetCss$navbar14 === void 0 ? void 0 : _targetCss$navbar14.iconStyle);
      }

      if ((_cssConstants["default"] === null || _cssConstants["default"] === void 0 ? void 0 : (_targetCss$navbar15 = _cssConstants["default"].navbar) === null || _targetCss$navbar15 === void 0 ? void 0 : _targetCss$navbar15.titleTextStyle) || (_cssConstants["default"] === null || _cssConstants["default"] === void 0 ? void 0 : (_targetCss$navbarMobi15 = _cssConstants["default"].navbarMobile) === null || _targetCss$navbarMobi15 === void 0 ? void 0 : _targetCss$navbarMobi15.titleTextStyle)) {
        titleTextStyle = (0, _assign["default"])(titleTextStyle, isMobile ? _cssConstants["default"].navbarMobile.titleTextStyle : _cssConstants["default"].navbar.titleTextStyle);
      }

      return {
        navbar: navbarStyle,
        burger: burgerStyle,
        icon: iconStyle,
        settingsIcon: settingsIconStyle,
        count: countStyle,
        navbarContainerLeftStyle: navbarContainerLeftStyle,
        navbarContainerRightStyle: navbarContainerRightStyle,
        backButtonContainerStyle: backButtonContainerStyle,
        backButtonIconStyle: backButtonIconStyle,
        learningStateIconStyle: learningStateIconStyle,
        titleIconStyle: titleIconStyle,
        navbarBorderStyle: navbarBorderStyle,
        disablityStyle: disablityStyle,
        feedbackStyle: feedbackStyle,
        titleTextStyle: titleTextStyle,
        update: {// visibility: this.props.onRefresh ? 'visible' : 'hidden',
        }
      };
    }
  }, {
    key: "goToSettings",
    value: function () {
      var _goToSettings = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var currentPath;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                currentPath = "".concat(_config["default"].baseRoute, "/").concat(_NavigationManagerCordova["default"].getCurrentPath());
                console.log('currentPath', currentPath);

                if (!(currentPath.indexOf(_Constants.SETTINGS_PATH) !== -1)) {
                  _context.next = 8;
                  break;
                }

                _context.next = 5;
                return (0, _TimeoutHelper.timeout)();

              case 5:
                _NavigationManagerCordova["default"].jumpBack();

                _context.next = 11;
                break;

              case 8:
                _context.next = 10;
                return (0, _TimeoutHelper.timeout)();

              case 10:
                _NavigationManagerCordova["default"].jumpToKesiUrl(_Constants.SETTINGS_PATH, currentPath); // NavigationManager.goTo(target.cordovaStartUrl())


              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function goToSettings() {
        return _goToSettings.apply(this, arguments);
      }

      return goToSettings;
    }()
  }, {
    key: "goHome",
    value: function goHome() {
      _NavigationManagerCordova["default"].setNavbarBackgroundColor(null);

      this.props.homeButtonFunc ? this.props.homeButtonFunc() : null;
    }
  }, {
    key: "goBack",
    value: function goBack() {
      console.log('goback called in navbar');
      return this.props.backButtonFunc || null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this,
          _dynamicStyles$icon;

      var dynamicStyles = this.getStyles();
      var logoLeft = _config["default"].navbarLogo ? /*#__PURE__*/_react["default"].createElement("img", {
        alt: 'Logo',
        onClick: _config["default"].useNavbarLogoAsHomeButton ? function () {
          _this4.goHome();
        } : function () {},
        src: _config["default"].navbarLogo,
        style: {
          height: '100%',
          position: 'absolute',
          left: '5%'
        }
      }) : null;
      var logoRight = _config["default"].navbarLogoRight ? /*#__PURE__*/_react["default"].createElement("img", {
        alt: 'Logo',
        src: _config["default"].navbarLogoRight,
        style: {
          height: '100%',
          position: 'relative',
          right: '-5%'
        }
      }) : null;

      var isConnected = _DeviceInfoHelper["default"].isOnline();

      var myErgoData = this.state.data[_DataStore.DATA_STORE_PATHS.ERGO_USER_DATA]; //    console.log('isLandscape & current Path', isLandscape, this.props.currentPath)

      var specificTitleIcon = _config["default"].titleIcon;
      var homeRegionCode = this.state.data[_DataStore.DATA_STORE_PATHS.TC_HOME_REGION_CODE];

      var degesActivated = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.DEGES_ACTIVATED);

      if (_config["default"].useDifferentNavbarIconWhenLoggedOut && degesActivated !== true) {
        specificTitleIcon = _config["default"].loggedOutTitleIcon;
      }

      var useNewIcon = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.TC_USE_NEW_ICON);

      if (useNewIcon) {
        console.log('useNewIcon', homeRegionCode);

        if (homeRegionCode === 'DE') {
          specificTitleIcon = _config["default"].titleIconDE;
        } else if (homeRegionCode === 'IT') {
          specificTitleIcon = _config["default"].titleIconIT;
        } else if (homeRegionCode === 'ES') {
          specificTitleIcon = _config["default"].titleIconES;
        } else if (homeRegionCode === 'PL') {
          specificTitleIcon = _config["default"].titleIconPL;
        }
      }

      var currentPath = _NavigationManagerCordova["default"].getCurrentPath();

      console.log('dynamicStyles icon', dynamicStyles.icon);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _config["default"].isQuizApp ? _NavigationBar["default"].navbarQuiz : _NavigationBar["default"].navbar,
        style: dynamicStyles.navbar
      }, _config["default"].showNavbarBorder ? /*#__PURE__*/_react["default"].createElement("div", {
        style: dynamicStyles.navbarBorderStyle
      }) : null, _config["default"].navbarBackground && /*#__PURE__*/_react["default"].createElement("div", {
        className: _NavigationBar["default"].navbarBackgroundImageContainer
      }, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
        alt: '',
        className: _NavigationBar["default"].navbarBackgroundImage,
        src: _config["default"].navbarBackground
      })), /*#__PURE__*/_react["default"].createElement("div", {
        style: dynamicStyles.navbarContainerLeftStyle
      }, /*#__PURE__*/_react["default"].createElement("span", {
        id: _NavigationBar["default"].burger,
        style: dynamicStyles.burger,
        onClick: this.props.onMenuClicked
      }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        name: "bars"
      })), this.props.showBackButton && !_config["default"].showCloseButtonInsteadOfBackButtonInNavbar ? /*#__PURE__*/_react["default"].createElement("span", {
        style: dynamicStyles.backButtonContainerStyle,
        onClick: this.goBack(),
        tabIndex: 0,
        id: 'backBtn'
      }, _config["default"].useTargetIcons && _config["default"].arrowLeft ? /*#__PURE__*/_react["default"].createElement("img", {
        src: _config["default"].arrowLeft,
        className: _NavigationBar["default"].backSvg,
        style: dynamicStyles.icon,
        alt: "Zurück-Pfeil",
        role: 'button'
      }) : /*#__PURE__*/_react["default"].createElement(_ArrowBackIos["default"], {
        style: dynamicStyles.backButtonIconStyle,
        className: 'doNotInvert',
        titleAccess: "Zurück-Pfeil",
        role: 'Button'
      })) : null), /*#__PURE__*/_react["default"].createElement("div", {
        className: _NavigationBar["default"].homeLogoLeft,
        style: this.props.showBackButton ? {
          left: '35px'
        } : {
          left: '10px'
        }
      }, _config["default"].showHomeButtonLeft && /*#__PURE__*/_react["default"].createElement("span", {
        className: _NavigationBar["default"].icon,
        style: dynamicStyles.icon,
        onClick: function onClick() {
          _this4.goHome();
        }
      }, /*#__PURE__*/_react["default"].createElement("img", {
        src: _config["default"].homeIcon,
        alt: "Zurück Button"
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _NavigationBar["default"].navbarLogo,
        onClick: _config["default"].homeButtonWorksAsBackButton ? this.goBack() : null
      }, logoLeft), _config["default"].hideTitle ? null : specificTitleIcon && _config["default"].forceTitleIcon ? /*#__PURE__*/_react["default"].createElement(_Image["default"], {
        alt: 'Titelicon',
        style: dynamicStyles.titleIconStyle,
        className: _NavigationBar["default"].titleImage,
        src: specificTitleIcon
      }) : !this.props.title && !_config["default"].defaultNavbarTitle ? specificTitleIcon ? /*#__PURE__*/_react["default"].createElement(_Image["default"], {
        alt: 'Titelicon',
        className: _NavigationBar["default"].titleImage,
        style: dynamicStyles.titleIconStyle,
        src: specificTitleIcon
      }) : null : /*#__PURE__*/_react["default"].createElement("div", {
        className: _NavigationBar["default"].title,
        style: dynamicStyles.titleTextStyle,
        dangerouslySetInnerHTML: {
          __html: _config["default"].forceDefaultTitle || !this.props.title ? _config["default"].defaultNavbarTitle : this.props.title
        }
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _NavigationBar["default"].navbarLogoRight
      }, logoRight), _config["default"].navigationBarImage && /*#__PURE__*/_react["default"].createElement("img", {
        src: _config["default"].navigationBarImage,
        onClick: this.props.onRefresh,
        id: _NavigationBar["default"].refresh,
        alt: 'Inhalt aktualisieren',
        style: dynamicStyles.update
      }), _config["default"].showFeedbackIcon ? this.renderFeedbackIcon(dynamicStyles) : null, _config["default"].showDisabilityIcons ? /*#__PURE__*/_react["default"].createElement("div", {
        style: dynamicStyles.disablityStyle
      }, _DeviceInfoHelper["default"].isBrowser() && window.innerWidth >= _cssConstants["default"].appMaxWidth && /*#__PURE__*/_react["default"].createElement(_FormatSize["default"], {
        titleAccess: 'Schriftgröße ändern',
        "aria-label": 'Schriftgröße ändern',
        role: 'button',
        id: 'toggleSizeBtn',
        tabIndex: 0,
        style: {
          height: '100%',
          marginRight: '10px'
        },
        onClick: function onClick() {
          return _this4.toggleFontSize();
        }
      }), /*#__PURE__*/_react["default"].createElement(_InvertColors["default"], {
        titleAccess: 'Farben invertieren',
        id: 'invertBtn',
        role: 'button',
        tabIndex: 0,
        style: {},
        onClick: function onClick() {
          return _this4.invertColors();
        }
      })) : null, /*#__PURE__*/_react["default"].createElement("div", {
        style: dynamicStyles.navbarContainerRightStyle
      }, _config["default"].showHomeButton && /*#__PURE__*/_react["default"].createElement("span", {
        className: _NavigationBar["default"].icon,
        style: dynamicStyles.icon,
        onClick: function onClick() {
          _this4.goHome();
        }
      }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        name: "home"
      })), _config["default"].showFilterFavoriteButton && this.props.showFavButton && /*#__PURE__*/_react["default"].createElement("span", {
        className: _NavigationBar["default"].icon,
        style: dynamicStyles.icon,
        onClick: function onClick() {
          if (_config["default"].useFavButtonAsRouteLink) {
            _NavigationManagerCordova["default"].goTo(_Constants.FAVS_PATH);
          } else {
            var newFavs = !_this4.state.data[_DataStore.DATA_STORE_PATHS.FILTER_FAVORITES];

            _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.FILTER_FAVORITES, newFavs);
          }
        }
      }, this.state.data[_DataStore.DATA_STORE_PATHS.FILTER_FAVORITES] || this.props.currentPath === "/".concat(_Constants.FAVS_PATH) || this.props.currentPath === _Constants.FAVS_PATH ? /*#__PURE__*/_react["default"].createElement("img", {
        alt: 'Lesezeichen Icon aktiv',
        src: _config["default"].bookmarkIconTrueNavBar
      }) : /*#__PURE__*/_react["default"].createElement("img", {
        alt: 'Lesezeichen Icon inaktiv',
        src: _config["default"].bookmarkIconFalseNavBar
      })), _config["default"].showNavbarBrowserUserIcon && (!_DeviceInfoHelper["default"].isBrowser() || !_config["default"].useWebLogin || _config["default"].isLoggedIn()) && /*#__PURE__*/_react["default"].createElement("span", {
        className: _NavigationBar["default"].icon,
        style: dynamicStyles.icon,
        onClick: function onClick() {
          if (_config["default"].useLoginBeforeUserPage) {
            if (_config["default"].isLoggedIn()) {
              _NavigationManagerCordova["default"].goTo('user');
            } else {
              if (_config["default"].openLogin) {
                _config["default"].openLogin();
              }
            }
          } else {
            _config["default"].isErgoApp ? _NavigationManagerCordova["default"].goTo('ergoUser') : _NavigationManagerCordova["default"].goTo('user');
          }
        },
        tabIndex: 0,
        id: 'userIcon'
      }, myErgoData && myErgoData.picture ? /*#__PURE__*/_react["default"].createElement("img", {
        alt: 'User Bild',
        style: {
          borderRadius: '50%',
          width: '25px'
        },
        src: 'data:image/jpeg;base64,' + myErgoData.picture
      }) : _config["default"].useUserIconInsteadOfChartIcon ? _config["default"].useTargetIcons && _config["default"].userIcon ? /*#__PURE__*/_react["default"].createElement("img", {
        alt: 'User Icon',
        src: _config["default"].userIcon,
        className: _NavigationBar["default"].userSvgIcon,
        style: dynamicStyles.learningStateIconStyle
      }) : /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        alt: 'User Icon',
        name: "user-circle-o",
        style: dynamicStyles.icon
      }) : /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        alt: 'Lernstand Icon',
        name: "line-chart",
        tabIndex: 0,
        style: dynamicStyles.learningStateIconStyle
      })), _config["default"].showNavbarConnectionsIcon && _DeviceInfoHelper["default"].isBrowser() && _DataStore["default"].compare(_DataStore.DATA_STORE_PATHS.LOGGED_IN, true) && /*#__PURE__*/_react["default"].createElement("span", {
        className: _NavigationBar["default"].icon,
        style: dynamicStyles.icon,
        onClick: function onClick() {
          _NavigationManagerCordova["default"].goTo('qdconnect');
        }
      }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        name: 'exchange',
        style: _DataStore["default"].compare(_DataStore.DATA_STORE_PATHS.CONNECT_PARTNER_AVAILABLE, true) ? {
          color: 'green'
        } : {
          color: 'gray'
        }
      })), _config["default"].showGlossarButton && /*#__PURE__*/_react["default"].createElement("span", {
        className: _NavigationBar["default"].icon,
        style: dynamicStyles.icon,
        onClick: function onClick() {
          _this4.props.showGlossary();
        }
      }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        alt: 'Glossar Icon',
        name: "book",
        style: {
          color: (dynamicStyles === null || dynamicStyles === void 0 ? void 0 : (_dynamicStyles$icon = dynamicStyles.icon) === null || _dynamicStyles$icon === void 0 ? void 0 : _dynamicStyles$icon.color) || 'white'
        }
      })), _config["default"].specificSettingsIcon && /*#__PURE__*/_react["default"].createElement("div", {
        className: _NavigationBar["default"].specificSettingsIconContainer,
        style: dynamicStyles.settingsIcon,
        onClick: function onClick() {
          _this4.goToSettings();
        }
      }, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
        className: _NavigationBar["default"].specificSettingsIcon,
        src: _config["default"].specificSettingsIcon,
        alt: 'Einstellungsicon'
      })), _config["default"].renderExtraSettingsButtonInNavbar && !_config["default"].specificSettingsIcon && /*#__PURE__*/_react["default"].createElement("span", {
        className: _NavigationBar["default"].icon,
        style: dynamicStyles.settingsIcon,
        onClick: function onClick() {
          _this4.goToSettings();
        }
      }, " ", isConnected ? _config["default"].useCogSettingsIcon ? /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        alt: 'Einstellungsicon',
        className: _NavigationBar["default"].settingsIcon,
        name: "cog"
      }) : /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        alt: 'Usericon',
        name: "user-circle",
        className: _NavigationBar["default"].settingsIcon
      }) : _config["default"].useCogSettingsIcon ? /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        alt: 'Einstellungsicon',
        className: _NavigationBar["default"].settingsIcon,
        style: {
          color: _config["default"].forcedSettingsIconColor || '#9B9B9B'
        },
        name: "cog"
      }) : /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        alt: 'Usericon',
        name: "user-circle",
        className: _NavigationBar["default"].settingsIcon,
        style: {
          color: _config["default"].forcedSettingsIconColor || '#9B9B9B'
        }
      })), (0, _KESI2Helper.isKesiMaster)() && /*#__PURE__*/_react["default"].createElement("span", {
        className: _NavigationBar["default"].icon,
        style: dynamicStyles.icon,
        onClick: function onClick() {
          var oldSetting = (0, _KESI2Helper.isRemoteControllingEnabled)();

          var currentId = _NavigationManagerCordova["default"].getCurrentId();

          var currentPath = _NavigationManagerCordova["default"].getCurrentPath();

          var currentScrollTop = _NavigationManagerCordova["default"].getScrollTop();

          console.log(currentId, currentPath, currentScrollTop);
          (0, _KESI2Helper.setRemoteSyncEnabled)(!oldSetting, currentId, currentPath, currentScrollTop);

          _this4.setState({
            remoteSyncEnabled: !oldSetting
          });
        }
      }, this.state.remoteSyncEnabled && isConnected ? /*#__PURE__*/_react["default"].createElement("img", {
        src: require('./assets/remote.svg')
      }) : /*#__PURE__*/_react["default"].createElement("img", {
        src: require('./assets/remote_off.svg')
      })), _config["default"].showReloadButtonInNavbar ? /*#__PURE__*/_react["default"].createElement("span", {
        className: _NavigationBar["default"].icon,
        style: dynamicStyles.icon,
        onClick: function onClick() {
          _this4.props.reloadContent();
        }
      }, /*#__PURE__*/_react["default"].createElement("img", {
        src: require('./assets/replay.png'),
        className: _NavigationBar["default"].settingsIcon
      })) : null, _config["default"].showWarningsIconInNavbar && this.state.data[_DataStore.DATA_STORE_PATHS.TC_WARNING_ACTIVATED] === false ? /*#__PURE__*/_react["default"].createElement("span", {
        className: _NavigationBar["default"].warningsIcon
      }, /*#__PURE__*/_react["default"].createElement("img", {
        src: require('./assets/warnings_off.svg'),
        className: _NavigationBar["default"].settingsIcon
      })) : null, _config["default"].useSettingsDialog ? /*#__PURE__*/_react["default"].createElement("span", {
        className: _NavigationBar["default"].tcSettings,
        onClick: function onClick() {
          var settingsEvent = new window.CustomEvent('showSettings');
          document.dispatchEvent(settingsEvent);

          _this4.props.showSettingsDialog();
        }
      }, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
        alt: 'Einstellungsicon',
        src: _config["default"].isNewDesign ? require('./assets/newUser.svg') : require('./assets/user.svg'),
        className: _NavigationBar["default"].settingsIcon
      })) : null), this.props.count >= 0 ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _NavigationBar["default"].count,
        style: dynamicStyles.count
      }, /*#__PURE__*/_react["default"].createElement("p", {
        className: _NavigationBar["default"].innerCount
      }, this.props.count)) : null, this.props.showBackButton && _config["default"].showCloseButtonInsteadOfBackButtonInNavbar && currentPath.indexOf('settings') !== 0 && currentPath.indexOf('user') !== 0 ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(_NavigationBar["default"].closeButton, " doNotInvert"),
        onClick: this.goBack()
      }, /*#__PURE__*/_react["default"].createElement(_Close["default"], {
        alt: 'Schließen Icon'
      })) : null);
    }
  }]);
  return NavigationBarGeneric;
}(_DataStoreComponent2["default"]);

exports["default"] = NavigationBarGeneric;
NavigationBarGeneric.propTypes = {
  title: _propTypes["default"].string,
  onMenuClicked: _propTypes["default"].func,
  onRefresh: _propTypes["default"].func,
  sidebarWidth: _propTypes["default"].string,
  sidebarDocked: _propTypes["default"].bool,
  isTraining: _propTypes["default"].bool,
  count: _propTypes["default"].number,
  showMenuButton: _propTypes["default"].bool,
  showBackButton: _propTypes["default"].bool,
  backButtonFunc: _propTypes["default"].func,
  homeButtonFunc: _propTypes["default"].func,
  showFavButton: _propTypes["default"].bool,
  reloadContent: _propTypes["default"].func,
  showSettingsDialog: _propTypes["default"].func,
  showGlossary: _propTypes["default"].func,
  currentPath: _propTypes["default"].string
};
NavigationBarGeneric.defaultProps = {
  title: '',
  sidebarWidth: '0',
  sidebarDocked: 0,
  onMenuClicked: null,
  onRefresh: null,
  isTraining: false,
  showMenuButton: true,
  currentPath: null
};